<h1 class="cg-h1">{{ 'am.pageTitle' | translate }}</h1>

<cigna-process-steps
  class="cg-hide-for-print"
  [steps]="steps$ | async"
  [activeStep]="1"
  [hiddenSteps]="hiddenSteps$ | async"
></cigna-process-steps>

<h3 class="cg-h3">{{ 'am.assign.header' | translate }}</h3>
<p class="cg-margin-top-none cg-margin-bottom-xl">
  {{ 'am.assign.subHeader' | translate }}
</p>

<form [formGroup]="assignTypeForm" style="max-width: 500px">
  <label
    class="cg-indent-label-text"
    for="accessTypeIndividual"
    data-test="access-type-form"
  >
    <input
      class="cg-indent-label-text__input"
      type="radio"
      formControlName="accessType"
      id="accessTypeIndividual"
      data-test="access-type-individual"
      value="individual"
    />
    <strong>{{ 'am.assign.form.individualLabelStrong' | translate }}</strong
    ><br />
    {{ 'am.assign.form.individualLabel' | translate }}
  </label>
  <label class="cg-indent-label-text" for="accessTypeBulk">
    <input
      class="cg-indent-label-text__input"
      type="radio"
      formControlName="accessType"
      id="accessTypeBulk"
      data-test="access-type-bulk"
      value="bulk"
    />
    <strong>{{ 'am.assign.form.bulkLabelStrong' | translate }}</strong
    ><br />
    {{ 'am.assign.form.bulkLabel' | translate }}
  </label>
</form>

<div class="cg-margin-top-xl">
  <cigna-page-step-navigation
    [showPrevious]="(hiddenSteps$ | async)?.includes(0) === false"
    [nextEnabled]="(entitlementsLoaded$ | async) && (allTinsLoaded$ | async)"
    [showCancel]="true"
    (previous)="previousScreen()"
    (next)="nextScreen()"
  >
  </cigna-page-step-navigation>
  <ng-container *ngIf="(allTinsLoaded$ | async) === false">
    <div class="cg-media">
      <div class="cg-media__img"><div class="cg-spinner"></div></div>
      <div class="cg-media__bd cg-margin-top-sm">Loading...</div>
    </div>
  </ng-container>
</div>
